import { createFileRoute } from '@tanstack/react-router';
import { OrdersClient } from '@/features/coordination-orders/OrdersClient';

export const Route = createFileRoute('/_shell/orders/')({
  component: OrdersClient,
});
